<div class="astrea-page-404 m-sm-4 m-2">
    <div class="container">

        <div class="p-4">
            <h1>404</h1>
            <h2>{{ 'page_404.page_not_found' | translate }}</h2>
            <p>{{ 'page_404.text' | translate }}</p>
            <span class="animation-underline">
                <a class="button-return mt-4" routerLink="/login" mat-button>
                    {{ 'page_404.return' | translate }}
                </a>
            </span>
        </div>

    </div>
</div>
